export const PROD_ENV_STRING = '';

export type TockEnvinronment =
  | 'test'
  | 'local'
  | 'staging'
  | 'rc'
  | 'demo'
  | typeof PROD_ENV_STRING;

const env = {
  get(domain: string): TockEnvinronment {
    let environment;
    const NODE_ENV = process.env.NODE_ENV;
    if (NODE_ENV === 'test') {
      environment = 'test';
    } else if (/localhost/i.test(domain)) {
      environment = 'local';
    } else if (/staging\./i.test(domain)) {
      environment = 'staging';
    } else if (/rc\./i.test(domain)) {
      environment = 'rc';
    } else if (/demo\./i.test(domain)) {
      environment = 'demo';
    } else {
      environment = PROD_ENV_STRING;
    }
    return environment as TockEnvinronment;
  },
};

export default env;
